module.exports = __webpack_public_path__ + "static/media/text.bdf2a150.svg";